import { createSelector } from 'reselect';
import { MonitoringState } from '../types/store';

// Возвращает плановые точки маршрута (Monitoring.planPoints)
export const monitoringPlanTrackSelector = createSelector(
  (state: { Monitoring: MonitoringState }) => state.Monitoring.planPoints,
  (planPoints) => planPoints
);
